export const RecordType = Object.freeze({
  USER: 0,
  SYSTEM: 1
});
